module.exports = __webpack_public_path__ + "static/media/building-fill.ee892029.svg";